exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sfondo {\n  height: 100%; }\n\n.sub-testata {\n  height: 400px;\n  overflow: hidden;\n  text-align: center;\n  background-size: cover;\n  background-position: center center; }\n\n.container {\n  padding-top: 40px; }\n\n.testata .logo {\n  padding: 10px 0;\n  margin: 0 10px !important;\n  max-width: 150px;\n  max-height: 60px; }\n\n.button-div {\n  padding: 60px 0;\n  text-align: center;\n  margin: 0;\n  margin-bottom: 140px; }\n\n.error_message {\n  text-align: center;\n  padding-top: 15%; }\n\n.approvazioni input, .checkbox.privacy input {\n  margin-right: 12px; }\n\n.checkbox.privacy {\n  margin-bottom: 20px; }\n\n.attiva_trasparenza {\n  color: #aea8a8; }\n\n.container {\n  background: #fff; }\n\n.privacy-link {\n  cursor: pointer;\n  font-weight: bold; }\n\n.privacy-link:hover {\n  text-decoration: underline !important; }\n\n.confirm_message {\n  text-align: center;\n  padding-bottom: 44px;\n  margin-bottom: 400px; }\n\n.modal.fade {\n  opacity: 1 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/andrea/Documents/Projects/SW40/landing-portale-privacy/src/app/privacy-page/privacy-page.component.scss
// module id = ../../../../../src/app/privacy-page/privacy-page.component.scss
// module chunks = main